// @mui
import { alpha, styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

// ----------------------------------------------------------------------

const CustomTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "width",
})(({ width, theme }) => ({
  "& fieldset": {
    display: "none",
  },
  "& .MuiOutlinedInput-root": {
    width,
    border: `solid 1px ${alpha(theme.palette.grey[500], 0.32)}`,
    transition: theme.transitions.create(["box-shadow", "width"], {
      duration: theme.transitions.duration.shorter,
    }),
    "&.Mui-focused": {
      boxShadow: theme.customShadows.z20,
      ...(width && {
        [theme.breakpoints.up("sm")]: {
          width: width || "214px",
        },
      }),
    },
  },
}));

export default CustomTextField;

export const CustomTextFieldForCart = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "width",
})(({ width, theme }) => ({
  "& .MuiInputLabel-root": {
    color: "#fda92d",
    fontSize: "14px",
  },

  "& .MuiOutlinedInput-root": {
    width: "214px",
    color: "#fda92d",
    height: "35px",

    transition: theme.transitions.create(["box-shadow", "width"], {
      duration: theme.transitions.duration.shorter,
    }),
    "& fieldset": {
      borderColor: "#fda92d",
    },
    "&:hover fieldset": {
      borderColor: "#fda92d",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fda92d",
      boxShadow: theme.customShadows.z20,
      ...(width && {
        [theme.breakpoints.up("sm")]: {
          width: width || "214px",
        },
      }),
    },
  },
}));
